import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import fonts from 'theme/fonts';
import paths from 'routes/paths';
import { panelAccent } from 'theme/panelAccent';
import { Gift, ArrowRight } from 'lucide-react';

/**
 * `fullWidth`: usado em ProducerProfile, onde este é o único card ao lado de
 * CardProducerProfile (não faz parte de uma grade 2-colunas como em
 * EstablishmentProfile — reaproveitar o CardSlot ali causava o cálculo de
 * `:nth-child` errado, colando o card sem margem e com largura de metade).
 */
export default function AffiliateEntryCard({ establishment = false, fullWidth = false }) {
  const navigate = useNavigate();

  return (
    <Wrapper $fullWidth={fullWidth}>
      <Header>
        <IconBox>
          <Gift size={18} color={colors.neutralLight} />
        </IconBox>
        <HeaderText>
          <Title>Programa de Indicação</Title>
          <Subtitle>Indique e ganhe recompensas por cada indicação</Subtitle>
        </HeaderText>
      </Header>

      <ActionButton
        type='button'
        onClick={() => navigate(establishment ? paths.dashboard.establishment.affiliate : paths.dashboard.affiliate)}
      >
        Ver minhas indicações
        <ArrowRight size={15} />
      </ActionButton>
    </Wrapper>
  );
}

const Wrapper = styled(Column)`
  background: ${colors.neutralLight};
  width: 100%;
  border-radius: 12px;
  padding: 20px;
  margin-top: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);

  ${({ $fullWidth }) => !$fullWidth && `
    @media screen and (min-width: ${breakpoints.lg}) {
      width: 49%;
      margin-top: 1%;
      margin-left: 1%;
    }
  `}
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

const IconBox = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: ${panelAccent(colors.occasionalPurple)};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Title = styled.h3`
  font-size: ${fonts.sizes.highlight};
  font-weight: ${fonts.weight.bold};
  color: ${colors.nightDark};
  margin: 0;
  line-height: 1.2;
`;

const Subtitle = styled.p`
  font-size: ${fonts.sizes.small};
  color: ${colors.night};
  margin: 0;
`;

const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 11px 16px;
  border-radius: 10px;
  border: none;
  background: ${panelAccent(colors.occasionalPurple)};
  color: #fff;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.9;
  }
`;
